import { faGrip, faList } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SearchInput, CheckboxGroup, FilterCount } from "../../components/ui";

function NameFilters({ filters, onFilterChange, viewMode, onViewModeChange, totalCount, filteredCount }) {
  const filterOptions = [
    { key: "disregardSensitive", label: "No sensitive", checked: filters.disregardSensitive },
    { key: "disregardF", label: "No D/F", checked: filters.disregardF },
    { key: "maxCharacter", label: "Under max chars", checked: filters.maxCharacter },
  ];

  return (
    <div className="space-y-3">
      {/* Search + View Toggle */}
      <div className="flex items-center gap-3">
        <SearchInput
          value={filters.searchTerm || ""}
          onChange={value => onFilterChange("searchTerm", value)}
          placeholder="Search names..."
          className="flex-1"
        />
        <div className="flex items-center border border-base-content/10 rounded-lg overflow-hidden">
          <button
            onClick={() => onViewModeChange("grid")}
            className={`p-2 ${viewMode === "grid" ? "bg-primary text-primary-content" : "text-base-content/50 hover:text-base-content"}`}
          >
            <FontAwesomeIcon icon={faGrip} />
          </button>
          <button
            onClick={() => onViewModeChange("table")}
            className={`p-2 ${viewMode === "table" ? "bg-primary text-primary-content" : "text-base-content/50 hover:text-base-content"}`}
          >
            <FontAwesomeIcon icon={faList} />
          </button>
        </div>
      </div>

      {/* Filter toggles + count */}
      <div className="flex items-center justify-between">
        <CheckboxGroup
          options={filterOptions}
          onChange={(key, checked) => onFilterChange(key, checked)}
        />
        <FilterCount filtered={filteredCount} total={totalCount} label="names" />
      </div>
    </div>
  );
}

export default NameFilters;
